import { Locale } from '~library/enums'
import { initI18n, libraryEn, libraryZhCN, libraryZhTW } from '~library/locales'
import zhCN from './langs/cn.json'
import en from './langs/en.json'
import zhTW from './langs/zh-TW.json'

export default initI18n({
  [Locale.EN]: { ...en, ...libraryEn },
  [Locale.ZH_TW]: { ...zhTW, ...libraryZhTW },
  [Locale.ZH_CN]: { ...zhCN, ...libraryZhCN }
})
